export default __webpack_public_path__ + "static/media/PR.a5990601.svg";